export const config = {
    server: 'https://api.gearboxconfigurator.com',
    cache: 'https://www.gearboxconfigurator.com'
    };
